/* eslint-disable @typescript-eslint/no-unnecessary-condition, @typescript-eslint/no-misused-spread, @typescript-eslint/restrict-template-expressions */
import type { MiddlewareResult } from "@smakecloud/api-client-helper";

export function routeMiddleware(): MiddlewareResult {
    const config = useRuntimeConfig();
    const slug = useSlug();

    const { locale } = storeToRefs(useLocalSettingsStore());

    const hasSlug = computed(() => slug.value !== undefined);
    const acceptLanguage = computed(() => locale.value ?? config.public.locale);

    return {
        beforeRequest: (options) => ({
            ...options,
            headers: {
                ...options.headers,
                "Accept-Language": acceptLanguage.value,
            },
            prefixUrl: `${config.public.productionApiBaseUrl}/${slug.value}`,
        }),
        enabled: hasSlug,
        key: [slug, acceptLanguage],
    };
}
